import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/ui/states';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="pl flex min-h-screen items-center justify-center" style={{ padding: 16 }}>
      <EmptyState
        title={t('notFound.title')}
        body={t('notFound.body')}
        action={
          <Link className="btn sm" to="/shipments">
            {t('notFound.back')}
          </Link>
        }
      />
    </div>
  );
}
